import axios from "axios";
import { snakePhp, snakeJavaSDM } from "./ApiService";
// For GET requests

export const LoginService = {
    signin(req){
        return axios.post(snakePhp + 'auth/sign-in', req);
    },
    getAvatar(){
        return axios.get(snakeJavaSDM + 'auth/sign-in');
    }
}


